function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M.667 9a8.333 8.333 0 1016.666 0A8.333 8.333 0 00.667 9zm13.045-3.13a.833.833 0 00-1.175.085l-4.98 5.756-2.134-2.134a.833.833 0 00-1.179 1.179l2.767 2.767a.833.833 0 001.22-.044l5.566-6.434a.833.833 0 00-.085-1.175z",
  fill: "#fff"
});

var SvgCheckSolid = function SvgCheckSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 18 18",
    fill: "none"
  }), _ref);
};

export default SvgCheckSolid;